import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { GuideParticipant, GuideInvoice, GuideReceived, GuideRemitted } from '../models/billing';

@Injectable({
  providedIn: 'root'
})
export class BillingService
{

  private API_BASE = environment.apiBaseUrl;
  private API_USER = environment.apiEndpoints.user;

  constructor(
    private _http: HttpClient,
  ) { }

  public async getGuideParticipants( filters: any ): Promise<GuideParticipant[] | undefined>
  {
    const result = await this._http.get<any>( `${this.API_BASE}${this.API_USER.billing.guideParticipants}`, { params: filters } ).toPromise();
    return result.data as GuideParticipant[];
  }

  public async getGuideInvoices( filters: any ): Promise<GuideInvoice[] | undefined>
  {
    const result = await this._http.get<any>( `${this.API_BASE}${this.API_USER.billing.guideInvoices}`, { params: filters } ).toPromise();
    return result.data as GuideInvoice[];
  }

  public async getGuideReceived( filters: any ): Promise<GuideReceived[] | undefined>
  {
    const result = await this._http.get<any>( `${this.API_BASE}${this.API_USER.billing.guideReceived}`, { params: filters } ).toPromise();
    return result.data as GuideReceived[];
  }

  public async getGuideRemited( filters: any ): Promise<any[] | undefined>
  {
    const result = await this._http.get<any>( `${this.API_BASE}${this.API_USER.billing.guideRemitted}`, { params: filters } ).toPromise();
    return result.data as any[];
  }

  public async generateInvoice( invoices: GuideInvoice[], participant: GuideParticipant ): Promise<string[]|undefined>
  {
    const result = await this._http.post<any>( `${this.API_BASE}${this.API_USER.billing.guideGenerateInvoice}`,  { invoices: invoices, participant: participant } ).toPromise();
    return result.data as string[];
  }

  public async receiveInvoices( recieveds: GuideReceived[] ): Promise<string[] | undefined>
  {
    const result = await this._http.post<any>( `${this.API_BASE}${this.API_USER.billing.guideReceiveInvoices}`, recieveds ).toPromise();
    return result.data as string[];
  }

  public async remitInvoices( remits: GuideRemitted[] ): Promise<string[] | undefined>
  {
    const result = await this._http.post<any>( `${this.API_BASE}${this.API_USER.billing.guideRemitInvoices}`, remits ).toPromise();
    return result.data as string[];
  }

}
